// modals
const USER_MODAL_ID = "USER_MODAL";
const MACHINE_USER_MODAL_ID = "MACHINE_USER_MODAL";
const GROUP_MODAL_ID = "GROUP_MODAL";
const CREATE_ORG_MODAL_ID = "CREATE_ORG_MODAL_ID";
const EDIT_ORG_MODAL_ID = "EDIT_ORG_MODAL_ID";
const LICENSE_MODAL_ID = "LICENSE_MODAL_ID";
const VERSION_MODAL_ID = "VERSION_MODAL_ID";
const PRODUCT_MODAL_ID = "PRODUCT_MODAL_ID";
const DOWNLOAD_MODAL_ID = "DOWNLOAD_MODAL_ID";
const EULA_MODAL_ID = "EULA_MODAL_ID";
const PRIVACY_NOTICE_MODAL_ID = "PRIVACY_NOTICE_MODAL_ID";
const FILTER_MODAL_ID = "FILTER_MODAL_ID";

// tables
const DEFAULT_PER_PAGE = 10;

// pages
const USERS_PAGE = "Users";
const LICENSES_PAGE = "License Pools";

// roles
const SUPERUSER = "super";
const STAFF_USER = "staff";
const PARTNER = "partner";
const MANAGER = "manager";
const MEMBER = "member";
const MACHINE = "machine";

// date formats
const PRETTY_DATE_FORMAT = "D MMM YYYY";
const PRETTY_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm z";
const SHORT_DATE_TIME_FORMAT = "ddd HH:mm";
const SHORT_PRETTY_DATE_TIME_FORMAT = "h:mm a · D MMM";

// filtering options
const SUBFILTER_EQUALS = "equals";
const SUBFILTER_DATE = "date";
const SUBFILTER_DATE_RANGE = "date_range";
const SUBFILTER_CONTAINS = "contains";

// date filters
const CREATED_BEFORE = "created_before";
const CREATED_AFTER = "created_after";
const CREATED_IN = "created_in";

const ZIPERASE_ID = "00000000-0000-0000-0000-000000000000";

// contract statuses
const TRIAL = "Trial";
const CONTRACTED = "Contracted";
const EXPIRED = "Expired";

export default {
  USER_MODAL_ID,
  MACHINE_USER_MODAL_ID,
  GROUP_MODAL_ID,
  CREATE_ORG_MODAL_ID,
  EDIT_ORG_MODAL_ID,
  LICENSE_MODAL_ID,
  VERSION_MODAL_ID,
  PRODUCT_MODAL_ID,
  DOWNLOAD_MODAL_ID,
  EULA_MODAL_ID,
  PRIVACY_NOTICE_MODAL_ID,
  FILTER_MODAL_ID,
  DEFAULT_PER_PAGE,
  USERS_PAGE,
  LICENSES_PAGE,
  PRETTY_DATE_FORMAT,
  PRETTY_DATE_TIME_FORMAT,
  SHORT_DATE_TIME_FORMAT,
  SHORT_PRETTY_DATE_TIME_FORMAT,
  ZIPERASE_ID,
  SUPERUSER,
  STAFF_USER,
  PARTNER,
  MANAGER,
  MEMBER,
  MACHINE,
  SUBFILTER_EQUALS,
  SUBFILTER_DATE,
  SUBFILTER_DATE_RANGE,
  SUBFILTER_CONTAINS,
  CREATED_BEFORE,
  CREATED_AFTER,
  CREATED_IN,
  CONTRACT_STATUSES: {
    TRIAL,
    CONTRACTED,
    EXPIRED
  }
};
